import { Container, Grid, Typography } from "@mui/material";
import ButtonBase from "@mui/material/ButtonBase";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/system";
import * as React from "react";
import ReactMarkdown from "react-markdown";
import Footer from "../../../Shared/Footer/Footer";
import Header from "../../../Shared/Header/Header";
import "./Portfolio";
import PortfolioData from "./PortfolioData";
const Portfolio = () => {
  const ImageButton = styled(ButtonBase)(({ theme }) => ({
    position: "relative",
    height: 200,
    [theme.breakpoints.down("sm")]: {
      width: "100% !important", // Overrides inline-style
      height: 100,
    },
    "&:hover, &.Mui-focusVisible": {
      zIndex: 1,
      "& .MuiImageBackdrop-root": {
        opacity: 0.15,
      },
      "& .MuiImageMarked-root": {
        opacity: 0,
      },
      "& .MuiTypography-root": {
        border: "4px solid currentColor",
      },
    },
  }));

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    background:
      "linear-gradient(45deg, rgb(45, 54, 76) 0%, rgb(37, 45, 63) 100%)!important",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    color: "white",
  };

  const ImageSrc = styled("span")({
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: "cover",
    backgroundPosition: "center 40%",
  });

  const Image = styled("span")(({ theme }) => ({
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.common.white,
  }));

  const ImageBackdrop = styled("span")(({ theme }) => ({
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create("opacity"),
  }));

  const ImageMarked = styled("span")(({ theme }) => ({
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: "absolute",
    bottom: -2,
    left: "calc(50% - 9px)",
    transition: theme.transitions.create("opacity"),
  }));

  const [open, setOpen] = React.useState(false);
  const [project, setProject] = React.useState({});
  const handleOpen = (id) => {
    setOpen(true);
    const singleProject = PortfolioData.find((data) => data.id === id);
    console.log(singleProject);
    setProject(singleProject);
  };
  const handleClose = () => setOpen(false);

  return (
    <div
      style={{
        background:
          "linear-gradient(45deg, rgb(45, 54, 76) 0%, rgb(37, 45, 63) 100%)",
      }}
    >
      <Header />
      <Container>
        {/* Modal */}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {project?.name}
            </Typography>
            <Box className="info">
              <ReactMarkdown>{project?.description}</ReactMarkdown>
              <Box>
                <a
                  style={{
                    color: "white",
                    textDecoration: "none",
                    border: "1px solid white",
                    padding: "5px",
                  }}
                  href={project?.liveLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  Live Link
                </a>
                <a
                  style={{
                    color: "white",
                    textDecoration: "none",
                    marginLeft: "10px",
                    border: "1px solid white",
                    padding: "5px",
                  }}
                  href={project?.clientSideCode}
                  target="_blank"
                  rel="noreferrer"
                >
                  Client Side Code
                </a>
                {project?.serverSideCode && (
                  <a
                    style={{
                      color: "white",
                      textDecoration: "none",
                      marginLeft: "10px",
                      border: "1px solid white",
                      padding: "5px",
                    }}
                    href={project?.serverSideCode}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Server Side Code
                  </a>
                )}
              </Box>
            </Box>
          </Box>
        </Modal>
        <Box>
          <Typography
            className="section-title"
            sx={{ color: "whitesmoke", mb: 10 }}
            variant="h3"
          >
            Portfolio
          </Typography>
        </Box>
        <Box sx={{ my: 5 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {PortfolioData.map((data) => (
              <Grid item xs={12} sm={12} md={4} key={data.id}>
                <ImageButton
                  onClick={() => handleOpen(data.id)}
                  focusRipple
                  style={{
                    width: "100%",
                    height: "200px",
                  }}
                >
                  <ImageSrc style={{ backgroundImage: `url(${data?.img})` }} />
                  <ImageBackdrop className="MuiImageBackdrop-root" />
                  <Image>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      color="inherit"
                      sx={{
                        position: "relative",
                        p: 4,
                        pt: 2,
                        pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                      }}
                    >
                      {data.name}
                      <ImageMarked className="MuiImageMarked-root" />
                    </Typography>
                  </Image>
                </ImageButton>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default Portfolio;
